import { TUserState } from '../../types/user';
import { IApplicationState } from '../../types/redux';

export const selectUser = (state: IApplicationState): TUserState => {
  return state.user;
};
